<template>
  <RouterLink class="lb-sidebar-brand" to="/">
    <img
      class="lb-sidebar-brand__logo"
      width="30"
      height="30"
      :src="require('@/assets/images/logo.svg')"
      :alt="$t('BAZAAR')"
    />

    <strong class="lb-sidebar-brand__title">
      {{ $t('PISHKHAN') }}
    </strong>
  </RouterLink>
</template>

<script>
export default {
  name: 'LbSidebarBrand',
};
</script>

<style lang="scss">
.lb-sidebar-brand {
  display: block;
  padding: 0 0.5rem;
  border-bottom: $lb-off-canvas-brand-link-border;
  height: $lb-off-canvas-brand-link-height;
  line-height: $lb-off-canvas-brand-link-height;
  white-space: nowrap;

  &__logo {
    width: $lb-off-canvas-brand-image-size;
    height: $lb-off-canvas-brand-image-size;
    margin-left: 0.4rem;

    @include rtl() {
      margin-right: 0.4rem;
    }
  }

  &__title {
    font-weight: 500;
    font-size: 0.8rem;
    color: grayscale(lighten($lb-off-canvas-color, 20%));
    vertical-align: middle;
  }
}

.off-canvas--collapsed {
  .lb-sidebar-brand__title {
    display: none;
  }
}
</style>
